import "core-js/modules/es6.number.constructor";
//
//
//
//
export default {
  name: 'Icons',
  props: {
    type: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: '#5c6b77'
    },
    size: {
      type: Number,
      default: 16
    }
  },
  computed: {
    styles: function styles() {
      return {
        fontSize: "".concat(this.size, "px"),
        color: this.color
      };
    }
  }
};